import { CONCEPTS } from "./concepts";

const List = ({ title, items, muted }) => (
  <div className="mt-6">
    <p className="text-xs font-semibold uppercase tracking-[0.16em] text-ink-faint">{title}</p>
    <ul className="mt-2 space-y-1.5">
      {items.map((t) => <li key={t} className={muted ? "text-ink-faint line-through decoration-line" : "text-ink-soft"}>{t}</li>)}
    </ul>
  </div>
);

export const ConceptNotes = ({ id }) => {
  const c = CONCEPTS[id];
  return (
    <div data-testid="concept-notes">
      <p className="text-xs font-semibold uppercase tracking-[0.16em] text-brand">Concept notes</p>
      <h2 className="font-display text-3xl text-ink mt-2">{c.title}</h2>
      <p className="text-lg text-ink mt-3 leading-relaxed">{c.purpose}</p>
      <List title="What appears" items={c.shows} />
      <div className="mt-6">
        <p className="text-xs font-semibold uppercase tracking-[0.16em] text-ink-faint">Hierarchy</p>
        <ol className="mt-2 flex flex-wrap gap-2">{c.hierarchy.map((h, i) => <li key={h} className="rounded-full bg-sunk px-3 py-1 text-sm text-ink-soft">{i + 1}. {h}</li>)}</ol>
      </div>
      <div className="mt-6 rounded-2xl bg-brand-soft px-4 py-3"><p className="text-sm text-ink-faint">Primary action</p><p className="text-ink font-medium">{c.primary}</p></div>
      {c.terms && (
        <div className="mt-6" data-testid="concept-terms">
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-ink-faint">Wording being explored</p>
          <ul className="mt-2 space-y-1.5">{c.terms.map((t) => <li key={t} className="text-ink-soft">{t}</li>)}</ul>
          <p className="text-sm text-ink-faint mt-2">Switch with “Words” in the top bar. Nothing is locked yet.</p>
        </div>
      )}
      <List title="Deliberately left out" items={c.removed} muted />
    </div>
  );
};
